var apiUrl
if ( location.hostname.indexOf('daichi.localhost.com') != -1) {
    apiUrl = "http://daichi.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('daichi-vue.ksystem.work') != -1) {
    apiUrl = "https://daichi-cms.ksystem.work/"
}
else if ( location.hostname.indexOf('daichi-stg-vue.ksystem.work') != -1) {
    apiUrl = "https://daichi-stg-cms.ksystem.work/"
}
else if ( location.hostname.indexOf('daichi.ksystem.work') != -1) {
    apiUrl = "https://daichi.ksystem.work/cms/"
}
else if ( location.hostname.indexOf('erp-demo.ksystem.work') != -1){
    apiUrl = "https://erp-demo.ksystem.work/cms/"
}
else if ( location.hostname.indexOf('onuma.localhost.com') != -1){
    apiUrl = "http://onuma.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('erp-demo2.ksystem.work') != -1){
    apiUrl = "https://erp-demo2.ksystem.work/cms/"
}
else if ( location.hostname.indexOf('shinozaki.work') != -1){
    apiUrl = "https://shinozaki.work/kerpdemo/cms/"
}
else if ( location.hostname.indexOf('onuma.ksystem.tokyo') != -1){
    apiUrl = "https://onuma.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('demo.ksystem.tokyo') != -1){
    apiUrl = "https://demo.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('demo-elix.ksystem.tokyo') != -1){
    apiUrl = "https://demo-elix.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('okp.ezerp.jp') != -1){
    apiUrl = "https://okp.ezerp.jp/cms/"
}
else if ( location.hostname.indexOf('okp.localhost.com') != -1){
    apiUrl = "http://okp.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('sankyo.localhost.com') != -1){
    apiUrl = "http://sankyo.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('sankyo.ksystem.tokyo') != -1){
    apiUrl = "https://sankyo.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('kuroda.ezerp.jp') != -1) {
    apiUrl = "https://kuroda.ezerp.jp/cms/"
}
else if ( location.hostname.indexOf('kuroda.localhost.com') != -1) {
    apiUrl = "http://kuroda.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('sankyo-sagar.localhost.com') != -1){
    apiUrl = "http://sankyo-sagar.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('yajima.localhost.com') != -1) {
    apiUrl = "http://yajima.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('sankyo.ezerp.jp') != -1) {
    apiUrl = "http://yajima.ezerp.com:8080/cms/"
}
else if ( location.hostname.indexOf('ksystem2.localhost.com') != -1) {
    apiUrl = "http://ksystem2.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('ksystem2.ezerp.jp') != -1) {
    apiUrl = "http://ksystem2.ezerp.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchise1.localhost.com') != -1) {
    apiUrl = "http://franchise1.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchise1.ezerp.jp') != -1) {
    apiUrl = "http://franchise1.ezerp.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchise.localhost.com') != -1) {
    apiUrl = "http://franchise.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchisee.localhost.com') != -1) {
    apiUrl = "http://franchisee.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchisee2.localhost.com') != -1) {
    apiUrl = "http://franchisee2.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchisee3.localhost.com') != -1) {
    apiUrl = "http://franchisee3.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchise.ezerp.jp') != -1) {
    apiUrl = "http://franchise.ezerp.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchise.ksystem.tokyo') != -1) {
    apiUrl = "https://franchise.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('franchisee.ksystem.tokyo') != -1) {
    apiUrl = "https://franchisee.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('franchisee2.ksystem.tokyo') != -1) {
    apiUrl = "https://franchisee2.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('franchisee3.ksystem.tokyo') != -1) {
    apiUrl = "https://franchisee3.ksystem.tokyo/cms/"
}
else if ( location.hostname.indexOf('franchisee1.localhost.com') != -1) {
    apiUrl = "http://franchisee1.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchisee1.ezerp.jp') != -1) {
    apiUrl = "http://franchisee1.ezerp.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchisee.localhost.com') != -1) {
    apiUrl = "http://franchisee.localhost.com:8080/cms/"
}
else if ( location.hostname.indexOf('franchisee.ezerp.jp') != -1) {
    apiUrl = "http://franchisee.ezerp.com:8080/cms/"
}
else if (location.hostname === 'localhost'){
    apiUrl = "http://localhost:8765/"
}

export default apiUrl
